module.exports = __webpack_public_path__ + "img/changer-poster-after.93a88694.jpg";